(ns app.components.headers.views
  (:require
   [re-com.core :as re-com :refer [at  title]]
   [app.components.headers.styles :refer [title-md normal-md regular-lg semibold-lg  bold-lg semibold-sm semibold-md bold-sm regular-sm title-lg bold-xl]]))

(def title-style-map
  {:title {:large  (title-md)
           :regular (title-lg)}
   :normal {:regular  (normal-md)
            :semibold (semibold-md)}
   :large {:regular (regular-lg)
           :semibold (semibold-lg)
           :bold (bold-lg)}
   :small {:semibold (semibold-sm)
           :bold (bold-sm)
           :regular (regular-sm)}
   :x-large {:bold (bold-xl)}})

(defn header [{:keys [label type size style onClick class]}]
  [title :label label :class (if (nil? class)(get-in title-style-map [type size]) class) :style style 
   :attr     {:on-click onClick}])
